<template>
  <div class="inner-base" :style="styles">
    <div class="wrap">
      <!-- <div class="bnr-title" v-html="bannerInfo.title"></div> -->
      <div class="btn-area">
        <span v-if="hasSubScrBtn" class="btn subscr-btn" @click.stop="onSubscrBtnClick">月額￥{{subscPrice}}だけで占う</span>
        <span v-if="hasFreeBtn" class="btn buy-btn" @click.stop="onBuyBtnClick"><span class="button-face">￥{{itemPrice}}<span class="tax-in">（税込）</span>で占う</span></span>
      </div>
      <p class="notice">占いの購入には<span class="link" @click="onLoginLinkClick">ログイン（登録無料）</span>が必要です。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingBanner',
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    itemPrice: {
      type: Number,
      default: null,
    },
    subscPrice: {
      type: Number,
      default: null,
    },
    buyLink: String,
    subscUrl: String,
    bannerInfo: {
      type: Object,
      default(){
        return {
          title: '<span class="name">暮れの酉</span>の<span class="emphasis">鳳凰数術</span>で',
          freeBtnFace: '無料で占う',
          colors: {
            background: '#fffbe3',
            baseText: 'black',
            emphasis: 'red',
            decos: 'blue',
            freeBtn: 'brown',
            freeBtnBg: 'white',
          }
        }
      }
    }
  },
  computed: {
    styles(){
      const info = this.bannerInfo.colors
      return {
        '--background': info.background,
        '--base-text': info.baseText,
        '--emphasis': info.emphasis,
        '--decos': info.decos,
        '--free-btn': info.freeBtn,
        '--free-btn-bg': info.freeBtnBg,
      }
    },
    hasFreeBtn(){
      return true
    },
    hasSubScrBtn(){
      return true
    }
  },
  methods: {
    onBuyBtnClick(){
      window.gtag('event', 'click', {
        'event_category': 'Deluxe-free-result-paid-content-button',
        'event_label': '10001',
      })
      location.href = this.$handoverParams(this.buyLink)
    },
    onSubscrBtnClick(){
      window.gtag('event', 'click', {
        'event_category': 'Deluxe-free-result-subsc-button',
        'event_label': '10001',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
    onLoginLinkClick(){
      location.href=this.$handoverParams(this.subscUrl)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
$l_col_background: var(--background);
$l_col_base_text: var(--base-text);
$l_col_emphasis: var(--emphasis);
$l_col_decos: var(--decos);
$l_col_free_btn: var(--free-btn);
$l_col_free_btn_bg: var(--free-btn-bg);

.inner-base {
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.8);
  color: $l_col_base_text;
  text-align: center;
  .wrap {
    width: 100%;
    max-width: 580px;
    margin: 0 auto;
    padding: 16px 20px 8px;
  }
  .bnr-title {
    width: 100%;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 4px;
    /deep/ .name {
      font-size: 16px;
    }
    /deep/ .emphasis {
      font-size: 18px;
      color: $l_col_emphasis;
    }
    &::before,
    &::after {
      content: "";
      display: inline-block;
      border: 1px solid $l_col_decos;
      background: $l_col_decos;
      height: 1px;
      width: 16px;
      border-radius: 2px;
      box-sizing: border-box;
    }
    &::after {
      transform: translate(0,-4px) rotate(-55deg);
    }
    &::before {
      transform: translate(0,-4px) rotate(55deg);
    }
  }

  .btn-area {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .btn {
      display: inline-flex;
      height: 45px;
      width: 48.4%;
      border-radius: 35px;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
      font-size: 15px;
      font-weight: bold;
      line-height: 1;
      vertical-align: top;
      cursor: pointer;

      &.free-btn {
        background: $l_col_free_btn_bg;
        color: $l_col_free_btn;
        border: 2px solid $l_col_free_btn;
      }

      &.subscr-btn {
        background: linear-gradient(86.53deg, #ff7497 21.4%, #cb8bff 76.64%);
        color: white;

        span {
          display: block;
          width: 100%;
          line-height: 1.2;
        }

        .lower {
          font-size: 12px;
        }
      }

      &.buy-btn {
        margin: 0 auto;
        font-weight: bold;
        color: white;
        z-index: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        border-radius: 100px;
        position:relative;
        background: $col_def_gradient;
        user-select: none;
        &::before {
          position:absolute;
          top:0;
          left:0;
          z-index:-1;
          box-sizing:border-box;
          border-radius:100px;
          padding: 1px;
          width:100%;
          height:100%;
          background:#fff;
          background-clip:content-box;
          content:"";
        }
        .button-face {
          color: $col_temp_key1;
          background: $col_def_gradient;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-family: 'Hiragino Kaku Gothic Pro', 'source-han-sans-japanese', -apple-system, BlinkMacSystemFont, sans-serif;
          .tax-in {
            display: inline-block;
            margin: 0 -0.5em;
          }
          /deep/ {
            .notice,
            .face-body{
              display: block;
              width: 100%;
              color: $col_temp_key1;
              //グラデ方向崩れるため個別指定
              background: $col_def_gradient;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            .notice {
              font-size: 0.8em;
              line-height: 1;
            }
          }
        }
        &.disable {
          pointer-events: none;
          background: #dcdfe2;
          .button-face {
            color: #dcdfe2;
            background: none;
            -webkit-text-fill-color: initial;
            -webkit-background-clip: border-box;
          }
        }
      }
    }
  }
}
.notice {
  font-size: 13px;
  color: $col_temp_gray6;
  .link {
    color: $col_temp_key1;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/FloatingBannerSubsc.vue